import { useEffect, useState } from 'react';
import { apiRequest } from '../../api/client';
import QrCode from './QrCode';
import { MemberAvatars } from './roomUi';
import { roomTitle } from './roomAppearance';
import './InvitePanel.css';

export const joinLink = (code: string) => `${window.location.origin}/join/${code}`;

// Show this to the room: anyone scans it (app or phone camera) and they're in. People appear as they join.
const InvitePanel = ({ room, onClose }: { room: any; onClose: () => void }) => {
  const [invite, setInvite] = useState<{ code: string; expiresAt: number } | null>(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(() => { apiRequest<any>(`/sessions/${room.sessionId}/invite`, { method: 'POST', body: '{}' }).then(setInvite).catch(e => setError(e.message)); }, [room.sessionId]);
  useEffect(() => { const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); }; window.addEventListener('keydown', onKey); return () => window.removeEventListener('keydown', onKey); }, [onClose]);
  const link = invite ? joinLink(invite.code) : '';
  const copy = async () => { try { await navigator.clipboard.writeText(link); setCopied(true); window.setTimeout(() => setCopied(false), 2000); } catch { /* Clipboard blocked; the link is shown below anyway. */ } };
  const others = (room.members || []).length - 1;

  return <div className="moment-backdrop invite-backdrop" role="dialog" aria-modal="true" aria-labelledby="invite-title" onClick={onClose}>
    <section className="invite" onClick={event => event.stopPropagation()}>
      <button className="invite__close" onClick={onClose} aria-label="Close">×</button>
      <p className="invite__eyebrow">INVITE TO {roomTitle(room).toUpperCase()}</p>
      <h2 id="invite-title">Scan to join</h2>
      <p className="invite__copy">Point a phone camera at the code. With the app, use <strong>Scan to join</strong> in Rooms.</p>
      <div className="invite__qr">{invite ? <QrCode value={link} size={260} label={`QR code to join ${roomTitle(room)}`} /> : <span>{error || 'Making your code…'}</span>}</div>
      {invite && <div className="invite__code"><span>Or enter code</span><strong>{invite.code.replace(/(.{4})/, '$1 ')}</strong></div>}
      {invite && <button className="invite__copylink" onClick={copy}>{copied ? '✓ Link copied' : 'Copy invite link'}</button>}
      <div className="invite__members" aria-live="polite">
        <MemberAvatars members={room.members || []} size={30} />
        <span>{others > 0 ? `${others} ${others === 1 ? 'person has' : 'people have'} joined` : 'Waiting for people to join…'}</span>
      </div>
      <button className="invite__done" onClick={onClose}>{others > 0 ? 'Done, everyone’s in' : 'Close'}</button>
    </section>
  </div>;
};

export default InvitePanel;
